export default __webpack_public_path__ + "media/wallpaper/three_thumbnail_large-d2663688.jpg";